import { useQuery } from '@tanstack/react-query';
import { type MyMemberInfo, memberInfoKey, requestMyMemberInfo } from './memberInfoApi';

/** The member's own half of the membership card — the name and ID printed on the front face. */
export interface MemberCardIdentity {
  firstName: string | null;
  lastName: string | null;
  mdvipId: string | null;
}

function emptyToNull(value: string | null | undefined): string | null {
  return value ? value : null;
}

export function mapToMemberCardIdentity(member: MyMemberInfo): MemberCardIdentity {
  return {
    firstName: emptyToNull(member?.firstName),
    lastName: emptyToNull(member?.lastName),
    mdvipId: emptyToNull(member?.mdvipId),
  };
}

/**
 * Name and MDVIP ID for the membership card, read from the shared `myMemberInfo` query/cache —
 * same key as {@link useMyProfile} and the Payments hooks, only the `select` differs, so mounting
 * the card next to any of them doesn't fire a second request.
 */
export function useMemberCardIdentity() {
  const { data, isPending, isError, error } = useQuery({
    queryKey: memberInfoKey,
    queryFn: requestMyMemberInfo,
    select: mapToMemberCardIdentity,
  });

  return { data, isPending, isError, error };
}
